<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">PAYROLL SLIP 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="print()">Print Slip</b-button>
          <b-button variant="primary mr-1" @click="email()">Email Slip</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
          <b-col lg="10">
            <b-row>
               <b-col md="6">
                  <b-input-group>
                    <b-input-group-prepend><label>Payroll Date</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.payrolldate" type='date'></b-form-input>
                  </b-input-group>
               </b-col>
            </b-row>
            <b-input-group>
                <b-input-group-prepend><label>Data Range</label></b-input-group-prepend>
                <b-form-radio-group  v-model="frmdata.project" name="radioResetFreq" class="mt-1" >
                    <b-form-radio :value="0">SELECTED CREW/EMPLOYEE</b-form-radio>
                    <b-form-radio :value="1">PER PROJECT/LOCATION</b-form-radio>
                </b-form-radio-group>
                  <b-form-input readonly v-model="frmdata.projectname" v-if="frmdata.project==1"></b-form-input>
                  <b-input-group-append v-if="frmdata.project==1">
                      <b-btn text="Button" @click="lkuCustomerShow=true" ><i class="fa fa-search"></i></b-btn>
                  </b-input-group-append>
            </b-input-group>
          </b-col> 
      </b-row>
      <b-card v-if="frmdata.project==0">
        <b-input-group>
            <b-input-group-prepend><span class="mt-1 mr-2">Print the following Employee : </span></b-input-group-prepend>
            <b-btn text="Button" @click="lkuCrewShow=true" size="sm" >
                <i class="fa plus-square"></i> Add Crew
            </b-btn>
            </b-input-group-append>
        </b-input-group>
        <div class="report-wraper">
              <b-row >
                  <div class="col-sm-4 col-lg-3" v-for="(inv,idx) in frmdata.arrCrewkey" :key="inv.crewkey">
                    <b-card :no-body="true">
                      <div class="p-3 clearfix">
                        <div class="h5 text-info mb-0 mt-2">{{inv.crewinfo}} <b-link @click="delCrew(idx)" class="ml-2">  <i class="fa fa-trash"></i></b-link></div>
                          <small class="text-muted">{{inv.jabatan}}</small>
                      </div>
                    </b-card>
                  </div>
              </b-row>
        </div>
      </b-card>
    </b-card>
      <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
          <lku-crew @click="onSelectLkuCrew"></lku-crew>
      </b-modal>        
    <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Client/Project" :centered="true">
        <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>        

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss">
  .invoicelist{
    ul {
        -webkit-column-count: 4;
        -moz-column-count: 4;
        column-count: 4;
    }
  }
    .input-group {
        .input-group-prepend {
          padding-bottom:2px;
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
   iframe {
        border: 1px solid #ccc;
        width: 100%;
        height: 11in;
    }    
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from 'moment';
import toastr from "mini-toastr";
import lkuCrew from "../lookup/lkuCrew";
import lkuCustomer from "../lookup/lkuCustomers";
import payroll from "../../apis/payroll";

toastr.init();

export default {
  components: { Loading, lkuCrew, lkuCustomer },
  mixins: [validationMixin],
  validations: {
        frmdata: {
            payrolldate: { required },
            projectid: {required : (function() {
                if ((this.frmdata.project || 0) == 0) {
                    return true;
                } else if ((this.frmdata.projectid || '')==''){
                    return false;
                } else return true;
            })},
            arrCrewkey: {required : (function() {
                if ((this.frmdata.project || 0) == 1) {
                    return true;
                } else if ((this.frmdata.arrCrewkey || []).length==0){
                    return false;
                } else return true;
            })},
        },
  }, 
  data() {
    return {
      lkuCrewShow:false,
      lkuCustomerShow:false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      frmdata:{projectid:'',project:1, arrCrewkey:[]}
    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    onSelectLkuCustomer: async function (_selected) {
        this.frmdata.projectname = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
        this.frmdata.projectid = _selected.customer_id;
        this.lkuCustomerShow=false;
    },
    onSelectLkuCrew(_selected) {
      const ada =this.frmdata.arrCrewkey.find(i => i.crewkey == _selected.crewkey);
      if (ada){
          toastr.error(`Crew/Employee "${_selected.crewnik}" sudah ada dalam List`)
      } else {
        this.frmdata.arrCrewkey.push({
            crewkey:_selected.crewkey,
            crewnik:_selected.crewnik,
            crewinfo: _selected.crewname.trim() + ' | ' + _selected.crewnik.trim() ,
            jabatan:_selected.jabatan});
      }
      // this.model.custcode=_selected.custcode;
      // this.model.CustName=_selected.CustName;
      this.lkuCrewShow=false;
      // this.lkuArInvData=invLookup;
      // for (var key in invLookup) {
      //     this.lkuArInvData[key] = invLookup[key];
      // }
    },
    delCrew : function (index) {
        if (index > -1) {
            this.frmdata.arrCrewkey.splice(index, 1);
        }
    },
    email: async function()
    {
          if (this.invalidFormdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('model obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "Error Info");
          } else {
              try {
                const data = {};
                data.payrolldate=moment(this.frmdata.payrolldate).format('YYYY-MM-DD'); 
                if (this.frmdata.project==1) {
                  data.projectid=this.frmdata.projectid;
                } else {
                  data.arrCrewkey = this.frmdata.arrCrewkey.reduce((newArr, item) => {
                      newArr.push(item.crewkey);
                      return newArr;
                  }, []);

                }

                   this.isLoading=true;
                  await payroll.emailmulti(data);
                  this.isLoading=false;
              } catch (error) {
                  this.isLoading=false;
                  if (error.message) {
                      toastr.error(error.message);
                  } else {
                      toastr.error(JSON.stringify(error));
                  }
              }
          }

    },
    print: async function()
    {
          if (this.invalidFormdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('model obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "Error Info");
          } else {
              try {
                const data = {};
                data.payrolldate=moment(this.frmdata.payrolldate).format('YYYY-MM-DD'); 
                if (this.frmdata.project==1) {
                  data.projectid=this.frmdata.projectid;
                } else {
                  data.arrCrewkey = this.frmdata.arrCrewkey.reduce((newArr, item) => {
                      newArr.push(item.crewkey);
                      return newArr;
                  }, []);

                }

                   this.isLoading=true;
                  this.reportUrl= await payroll.printmulti(data);
                  this.isLoading=false;
                  this.showReport=true;
              } catch (error) {
                  this.isLoading=false;
                  if (error.message) {
                      toastr.error(error.message);
                  } else {
                      toastr.error(JSON.stringify(error));
                  }
              }
          }
    },
    close(){
      router.push("home");
    },    
  }
};
</script>
